import React, { Component } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Divider from "@material-ui/core/Divider"
import Grid from "@material-ui/core/Grid"

class ActionBarComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
    }
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }
  render() {

    return (
      <div>
        <Divider />
        <div className={this.props.classes.actionBarOuter}>
          {/* <div className={this.props.classes.actionBarInner}> */}
          <Grid container className={this.props.classes.actionBarInner}>
            <Grid
              item
              md={6}
              sm={12}
              className={this.props.classes.actionButtonWrapper}
            >
              {/* <div className={this.props.classes.actionButtonWrapper}> */}
              {this.props.buttonChildren &&
                this.props.buttonChildren(this.props.classes)}
              {/* </div> */}
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              className={this.props.classes.actionBarSort}
            >
              {/* <div className={this.props.classes.actionBarSort}> */}
              {this.props.sortChildren &&
                this.props.sortChildren(this.props.classes)}
              {/* </div> */}
            </Grid>
          </Grid>
          {/* </div> */}
        </div>
        {/* <Divider /> */}
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(ActionBarComponent)
